var JobListing = {};

(function ( $ ) {

    var container = $( '.js-job-container' );
    var filterByCategoryButton = $( '.filter-by-category' );
    var showTheRestButtonClass = '.job-listing-show-the-rest';
    var showTheRestButton = $( showTheRestButtonClass );
    var sortField = $( '#job-listing-sort' );
    var loader = container.children( 'div.loader' );
    var sortMode;
    var data;
    var filterByCategory;

    var showShowTheRestButton = function () {
        $( showTheRestButtonClass ).each(function( index ) {
            element = $(this).parent();
            element.removeClass( element.data( 'hideClass' ) );
            element.addClass( element.data( 'showClass' ) );
        } );
    };

    var hideShowTheRestButton = function () {
        $( showTheRestButtonClass ).each(function( index ) {
            element = $(this).parent();
            element.removeClass( element.data( 'showClass' ) );
            element.addClass( element.data( 'hideClass' ) );
        } );
    };

    var removeBrokenLogos = function () {
        $( '.tablist-item img' ).on( 'error', function () {
            var element = $( this );

            // Replace image with company name
            var company = element.prop( 'alt' );
            var companyUrl = element.prop( 'src' );
            element.parent().addClass( 'job-image-logo-text' ).append( '<div class="text-left" data-url="' + companyUrl + '">' + company + '</div>' );
            element.siblings( '.company-name' ).hide();

            element.off( 'error' );
            element.remove();
        } );
    };

    var loadData = function () {
        var jobListingData = $( '#dataJobListing' );

        if ( jobListingData.length === 0 ) {
            return;
        }

        data = JSON.parse( jobListingData.text() );

        if (data.count === 0) {
            return;
        }

        var ajaxData = {
            action: 'get_initial_ponty_jobs',
            count: data.count,
            post_type: data.postType
        };

        if ( typeof filterByCategory !== 'undefined' && filterByCategory != 'all') {
            ajaxData.filter_by_category = filterByCategory;
        }

        if ( typeof sortMode !== 'undefined' ) {
            ajaxData.sort_mode = sortMode;
        }

        $.ajax( {
            url: ajaxURL,
            method: 'GET',
            dataType: 'json',
            data: ajaxData,
            beforeSend: function () {
                hideShowTheRestButton();
                sortField.parents( 'div.text-center' ).hide();
                loader.show();
            },
            success: function ( result ) {
                container.html( '' );
                container.html( result.html );

                removeBrokenLogos();

                if ( result.count >= result.total) {
                    hideShowTheRestButton();
                }

                if ( result.count < result.total) {
                    showShowTheRestButton();
                }
            },
            error: function ( result ) {
                console.error( result );
            },
            complete: function ( result ) {
                if(container.html() == '') {
                    var noData = container.data('nodata');
                    container.html('<div class="tablist-item"><div class="item-container"><div class="name">' + noData + '</div></div></div>');
                }

                sortField.parents( 'div.text-center' ).show();
                loader.hide();
            }
        } );
    };

    var showTheRest = function () {
        var ajaxData = {
            action: 'get_rest_ponty_jobs',
            offset: data.count,
            post_type: data.postType
        };

        if ( typeof filterByCategory !== 'undefined' && filterByCategory != 'all') {
            ajaxData.filter_by_category = filterByCategory;
        }

        if ( typeof sortMode !== 'undefined' ) {
            ajaxData.sort_mode = sortMode;
        }

        $.ajax( {
            url: ajaxURL,
            method: 'GET',
            dataType: 'json',
            data: ajaxData,
            beforeSend: function () {
                hideShowTheRestButton();
                loader.show();
            },
            success: function ( result ) {
                container.append( result.html );

                removeBrokenLogos();
            },
            error: function ( result ) {
                console.error( result );
            },
            complete: function () {
                loader.hide();
            }
        } );
    };

    JobListing.getListingData = function () {
        var jobListingData = $( '#dataJobListing' );
        return jobListingData.length ? JSON.parse(jobListingData.text()) : {};
    };

    JobListing.init = function () {
        var jobListingData = JobListing.getListingData();

        // Set default category
        if (typeof jobListingData.defaultCategory !== 'undefined') {
            filterByCategory = jobListingData.defaultCategory;
            $('.filter-by-category').removeClass('active');
            $('.filter-by-category[data-category="'+jobListingData.defaultCategory+'"]').addClass('active');
        }

        loadData();

        showTheRestButton.click( function ( e ) {
            e.preventDefault();
            filterByCategory = $( '.filter-by-category.active' ).data('category');
            showTheRest();
        } );

        filterByCategoryButton.click( function ( e ) {
            e.preventDefault();
            filterByCategory = $( this ).data('category');
            $( '.filter-by-category' ).removeClass('active');
            $( this ).addClass('active');
            loadData();
        } );

        sortField.change( function () {
            sortMode = $( this ).val();
            loadData();
        } );
    };

    if ( container.length ) {
        $( JobListing.init );
    }
})( jQuery );